import {
	GLOBAL_SELECTED_PRODUCT_DATA,
	GLOBAL_CHATBOT_ID_DATA,
	GLOBAL_AUTHORAI_ID,
	GLOBAL_ASK_YOUR_DATA_ID,
	GLOBAL_DATE_TYPE_DATA,
	GLOBAL_START_DATE,
	GLOBAL_END_DATE,
	GLOBAL_ROUTES_UPDATE,
	DASHBOARD_TAB_UPDATE,
	PRODUCT_TAB_UPDATE,
	KBUTILITY_CHATBOT,
	DESIGNATION_UPDATE,
	USERS_UPDTAE,
	REPORT_TYPE,
	REPORT_TYPE_UPDATE,
	TASKPDF_CHAT_UPDATE,
	SITE_UPDATE,
	TEAM_TYPE_UPDATE,
	SELECTED_PLATFORM,
	DOCKER_STATUS_CHECK,
	DOCKER_STATUS_CHECK_TASKSCRIBE,
	PROMPT_AI_SELECTED_INSTANCE,
} from '../../common/actionTypes';

const INITIAL_STATE = {
	globalChatbotID: null,
	globalAuthorAIID: null,
	globalAskYourDataID: null,
	globalDateType: null,
	globalStartDate: null,
	globalEndDate: null,
	previousRoute: null,
	dashboardTab: true,
	productTab: null,
	kbutilityChatbot: null,
	designations: null,
	userIds: ['1'],
	reportType: null,
	taskPdfCurrentChat: null,
	sitesId: [],
	team_type: null,
	dockerStatus: false,
	taskscribedockerStatus: false,
	promptAISelectedInstance:{},
};

const GlobalDataReducer = (state = INITIAL_STATE, action) => {
	if (action.type === undefined) {
		return state;
	}
	switch (action.type) {
		case GLOBAL_SELECTED_PRODUCT_DATA: {
			return {
				...state,
				globalSelectedProduct: action.payload
			}
		}
		case GLOBAL_CHATBOT_ID_DATA: {
			return {
				...state,
				globalChatbotID: action.payload,
			};
		}
		case GLOBAL_AUTHORAI_ID: {
			return {
				...state,
				globalAuthorAIID: action.payload,

			};
		}
		case GLOBAL_ASK_YOUR_DATA_ID: {
			return {
				...state,
				globalAskYourDataID: action.payload,

			};
		}
		case GLOBAL_DATE_TYPE_DATA: {
			return {
				...state,
				globalDateType: action.payload,
			};
		}
		case GLOBAL_START_DATE: {

			return { ...state, globalStartDate: action.payload };
		}
		case GLOBAL_END_DATE: {

			return { ...state, globalEndDate: action.payload };
		}
		case GLOBAL_ROUTES_UPDATE: {
			return { ...state, previousRoute: action.payload }
		}
		case DASHBOARD_TAB_UPDATE: {
			return { ...state, dashboardTab: action.payload }
		}
		case PRODUCT_TAB_UPDATE: {
			return { ...state, productTab: action.payload }
		}
		case KBUTILITY_CHATBOT: {
			return { ...state, kbutilityChatbot: action.payload }
		}
		case DESIGNATION_UPDATE: {
			return { ...state, designations: action.payload }
		}
		case USERS_UPDTAE: {
			return { ...state, userIds: action.payload }
		}
		case REPORT_TYPE_UPDATE: {
			return { ...state, reportType: action.payload }
		}
		case TASKPDF_CHAT_UPDATE: {
			return { ...state, taskPdfCurrentChat: action.payload }
		}
		case SITE_UPDATE: {
			return { ...state, sitesId: action.payload }
		}
		case TEAM_TYPE_UPDATE: {
			return { ...state, team_type: action.payload }
		}
		case SELECTED_PLATFORM: {
			return { ...state, selectedPlatform: action.payload }
		}
		case DOCKER_STATUS_CHECK: {
			return { ...state, dockerStatus: action.payload }
		}
		case PROMPT_AI_SELECTED_INSTANCE: {
			return { ...state, promptAISelectedInstance: action.payload }
		}
		default:
			return state;
	}
};

export default GlobalDataReducer;
